/* Banque hors ligne : manifeste en localStorage, audios dans le Cache Storage.
   Matching par mots-clés — logique validée dans la maquette. */

import { api } from './api';

const BANK_KEY = 'olivia-offline-bank';
const AUDIO_CACHE = 'olivia-audio';

export const OFFLINE_FALLBACK =
  "Petite coupure réseau de mon côté — même dupliqué, je dépends du wifi. Reposez-moi ça dans un instant, ou tentez une question plus classique, j'ai des réserves.";

export const normTxt = (s) => s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

export function loadBank() {
  try {
    return JSON.parse(localStorage.getItem(BANK_KEY)) || [];
  } catch {
    return [];
  }
}

export function saveBank(entries) {
  localStorage.setItem(BANK_KEY, JSON.stringify(entries));
}

export function offlineAnswer(bank, text) {
  const words = normTxt(text).split(/\W+/).filter((w) => w.length > 2);
  let best = null;
  let bestScore = 0;
  for (const e of bank) {
    const keys = normTxt(`${e.question} ${e.keywords || ''}`).split(/\W+/).filter((w) => w.length > 2);
    let score = 0;
    for (const w of words) if (keys.includes(w)) score += 1;
    if (score > bestScore) {
      bestScore = score;
      best = e;
    }
  }
  return bestScore > 0 ? best : null;
}

/* Télécharge le pack (/api/offline_pack) : manifeste en localStorage + mp3 en Cache Storage. */
export async function preloadPack(onProgress) {
  const pack = await api.get('/api/offline_pack');
  saveBank(pack.entries);
  const withAudio = pack.entries.filter((e) => e.audio_url);
  let cached = 0;
  if ('caches' in window && withAudio.length) {
    const cache = await caches.open(AUDIO_CACHE);
    for (const entry of withAudio) {
      try {
        await cache.add(entry.audio_url);
        cached += 1;
      } catch {
        /* audio manquant : le texte reste disponible */
      }
      onProgress?.(cached, withAudio.length);
    }
  }
  return { entries: pack.entries.length, audios: cached, withAudio: withAudio.length };
}

/* Précharge les audios d'un manifeste quelconque (banque hors ligne ou discours)
   dans le Cache Storage, sans toucher au manifeste texte de la banque invités. */
export async function preloadAudios(entries, onProgress) {
  const withAudio = entries.filter((e) => e.audio_url);
  let cached = 0;
  if ('caches' in window && withAudio.length) {
    const cache = await caches.open(AUDIO_CACHE);
    for (const entry of withAudio) {
      try {
        await cache.add(entry.audio_url);
        cached += 1;
      } catch {
        /* audio manquant : le texte reste affichable */
      }
      onProgress?.(cached, withAudio.length);
    }
  }
  return { audios: cached, withAudio: withAudio.length };
}

export async function cachedAudioUrl(audioUrl) {
  if (!audioUrl || !('caches' in window)) return null;
  const cache = await caches.open(AUDIO_CACHE);
  const match = await cache.match(audioUrl);
  if (!match) return null;
  return URL.createObjectURL(await match.blob());
}

export async function countCachedAudios(entries) {
  if (!('caches' in window)) return 0;
  const cache = await caches.open(AUDIO_CACHE);
  let n = 0;
  for (const e of entries) {
    if (e.audio_url && (await cache.match(e.audio_url))) n += 1;
  }
  return n;
}
